import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
class ConnectedSite {
  static fromProto(proto) {
    let m = new ConnectedSite();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.gscSiteUrl !== 'undefined') {
      toReturn['gscSiteUrl'] = this.gscSiteUrl;
    }
    if (typeof this.gscUserId !== 'undefined') {
      toReturn['gscUserId'] = this.gscUserId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.isBroken !== 'undefined') {
      toReturn['isBroken'] = this.isBroken;
    }
    if (typeof this.deleted !== 'undefined') {
      toReturn['deleted'] = this.deleted;
    }
    return toReturn;
  }
}
class CollectRecordsRequest {
  static fromProto(proto) {
    let m = new CollectRecordsRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class CollectRecordsResponse {
  static fromProto(proto) {
    let m = new CollectRecordsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class DeleteSiteRequest {
  static fromProto(proto) {
    let m = new DeleteSiteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DeleteSiteResponse {
  static fromProto(proto) {
    let m = new DeleteSiteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class GetAvailableGSCSitesRequest {
  static fromProto(proto) {
    let m = new GetAvailableGSCSitesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetAvailableGSCSitesResponse {
  static fromProto(proto) {
    let m = new GetAvailableGSCSitesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sites !== 'undefined') {
      toReturn['sites'] = this.sites;
    }
    return toReturn;
  }
}
class GetKeywordsRequest {
  static fromProto(proto) {
    let m = new GetKeywordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetKeywordsResponse {
  static fromProto(proto) {
    let m = new GetKeywordsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    return toReturn;
  }
}
class GetSiteRequest {
  static fromProto(proto) {
    let m = new GetSiteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSiteResponse {
  static fromProto(proto) {
    let m = new GetSiteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.site !== 'undefined') {
      toReturn['site'] = this.site;
    }
    return toReturn;
  }
}
class LookupSitesRequest {
  static fromProto(proto) {
    let m = new LookupSitesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class LookupSitesResponse {
  static fromProto(proto) {
    let m = new LookupSitesResponse();
    m = Object.assign(m, proto);
    if (proto.sites) {
      m.sites = proto.sites.map(ConnectedSite.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sites !== 'undefined' && this.sites !== null) {
      toReturn['sites'] = 'toApiJson' in this.sites ? this.sites.toApiJson() : this.sites;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class SetInitialKeywordsRequest {
  static fromProto(proto) {
    let m = new SetInitialKeywordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class SetInitialKeywordsResponse {
  static fromProto(proto) {
    let m = new SetInitialKeywordsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class SetKeywordsRequest {
  static fromProto(proto) {
    let m = new SetKeywordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    return toReturn;
  }
}
class SetKeywordsResponse {
  static fromProto(proto) {
    let m = new SetKeywordsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class SetSiteRequest {
  static fromProto(proto) {
    let m = new SetSiteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.gscSiteUrl !== 'undefined') {
      toReturn['gscSiteUrl'] = this.gscSiteUrl;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class SetSiteResponse {
  static fromProto(proto) {
    let m = new SetSiteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'google-search-console-api.vendasta-local.com',
  'test': '',
  'demo': 'google-search-console-demo.apigateway.co',
  'prod': 'google-search-console-prod.apigateway.co',
  'production': 'google-search-console-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let RecordsApiService = /*#__PURE__*/(() => {
  class RecordsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    collectRecords(r) {
      const request = r.toApiJson ? r : new CollectRecordsRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Records/CollectRecords", request.toApiJson(), this.apiOptions()).pipe(map(resp => CollectRecordsResponse.fromProto(resp)));
    }
    setInitialKeywords(r) {
      const request = r.toApiJson ? r : new SetInitialKeywordsRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Records/SetInitialKeywords", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetInitialKeywordsResponse.fromProto(resp)));
    }
    setKeywords(r) {
      const request = r.toApiJson ? r : new SetKeywordsRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Records/SetKeywords", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetKeywordsResponse.fromProto(resp)));
    }
    getKeywords(r) {
      const request = r.toApiJson ? r : new GetKeywordsRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Records/GetKeywords", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetKeywordsResponse.fromProto(resp)));
    }
  }
  RecordsApiService.ɵfac = function RecordsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecordsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  RecordsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecordsApiService,
    factory: RecordsApiService.ɵfac,
    providedIn: 'root'
  });
  return RecordsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RecordService = /*#__PURE__*/(() => {
  class RecordService {
    constructor(api) {
      this.api = api;
    }
    getKeywords(partnerID, businessID) {
      const req = new GetKeywordsRequest({
        partnerId: partnerID,
        businessId: businessID
      });
      return this.api.getKeywords(req).pipe(map(resp => resp.keywords));
    }
    setKeywords(partnerID, businessID, keywords) {
      const req = new SetKeywordsRequest({
        partnerId: partnerID,
        businessId: businessID,
        keyword: keywords
      });
      return this.api.setKeywords(req).pipe(map(resp => resp.success));
    }
  }
  RecordService.ɵfac = function RecordService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecordService)(i0.ɵɵinject(RecordsApiService));
  };
  RecordService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecordService,
    factory: RecordService.ɵfac,
    providedIn: 'root'
  });
  return RecordService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SitesApiService = /*#__PURE__*/(() => {
  class SitesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSite(r) {
      const request = r.toApiJson ? r : new GetSiteRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Sites/GetSite", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSiteResponse.fromProto(resp)));
    }
    setSite(r) {
      const request = r.toApiJson ? r : new SetSiteRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Sites/SetSite", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetSiteResponse.fromProto(resp)));
    }
    deleteSite(r) {
      const request = r.toApiJson ? r : new DeleteSiteRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Sites/DeleteSite", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeleteSiteResponse.fromProto(resp)));
    }
    lookupSites(r) {
      const request = r.toApiJson ? r : new LookupSitesRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Sites/LookupSites", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupSitesResponse.fromProto(resp)));
    }
    getAvailableSites(r) {
      const request = r.toApiJson ? r : new GetAvailableGSCSitesRequest(r);
      return this.http.post(this._host + "/googlesearchconsole.v1.Sites/GetAvailableSites", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableGSCSitesResponse.fromProto(resp)));
    }
  }
  SitesApiService.ɵfac = function SitesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SitesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SitesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SitesApiService,
    factory: SitesApiService.ɵfac,
    providedIn: 'root'
  });
  return SitesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { GetKeywordsRequest, GetKeywordsResponse, RecordService, SetKeywordsRequest, SetKeywordsResponse };
